import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { eyebrowSx, sectionTitleSx } from '../style/helpStyles';

const SectionHeading = ({
  eyebrow, title, titleVariant, mb, align, eyebrowSize, titleSize,
}) => (
  <Box mb={mb} sx={{ textAlign: align }}>
    <Typography component="span" sx={{ ...eyebrowSx, fontSize: eyebrowSize }}>{eyebrow}</Typography>
    <Typography
      variant={titleVariant}
      component="h2"
      sx={{ ...sectionTitleSx, marginTop: '8px', fontSize: titleSize }}
    >
      {title}
    </Typography>
  </Box>
);

SectionHeading.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  mb: PropTypes.number,
  align: PropTypes.string,
  eyebrowSize: PropTypes.number,
  titleSize: PropTypes.number,
};

SectionHeading.defaultProps = {
  titleVariant: 'h4',
  mb: 3,
  align: 'inherit',
  eyebrowSize: eyebrowSx.fontSize,
  titleSize: null,
};

export default SectionHeading;
